// Pickup and delivery dates are managed in the Store Pickup app since October 2026:
// Products override rules (seasonal products) and Lead time rules (72/48 Stunden,
// 7 and 10 Days Lead-Time). The old date code (crDateCallback, crDeliveryDateCallback,
// crPickupCallback, crDeliveryTimeCallback) was removed so the app's rules apply.

document.addEventListener('crDeliveryActivated', function (e) {
  setTimeout(function(){
    var minOrderMessage = storePickup.translations.en.minOrderMessage
    jqCR('.min-order-message').html(minOrderMessage);
    jqCR('#cr-flexible').remove()
  }, 400)  
})
// Save the notes values
var textarea = document.getElementById('CartSpecialInstructions');
let debounceTimer;

textarea.addEventListener('input', (event) => {
  // Clear any existing timer to restart the debounce period
  clearTimeout(debounceTimer);

  // Set a new timer. When the user stops typing for 500ms, this code executes.
  debounceTimer = setTimeout(() => {
    const updatedValue = event.target.value;
    console.log(updatedValue); // Process the value here
    updateNotes(updatedValue)
  }, 500);
});

function updateNotes(noteValue) {
  fetch(window.Shopify.routes.root + 'cart/update.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify({
  note: noteValue
  })
  })
  .then(response => response.json())
  .then(data => console.log(data));
}
// end save notes values

var special = false;
var noSpecial = false;

for (var i = 0; i < crItems.length; i++ ){
  var itemCollections = crItems[i].collections
  var itemTitle = crItems[i].name;
  if (itemTitle === 'Pickup Instore') continue;
  if (itemTitle.indexOf('Aufpreis für Kuchenbeschriftung') > -1) continue
  if (itemTitle.indexOf('Surcharge for Writing on the Cake') > -1) continue
  console.log({itemTitle})  
  console.log('-->', itemCollections)
 
  if (itemCollections.toLowerCase().indexOf('Kuchen zu Heute oder Morgen'.toLowerCase()) > -1 ||
      itemCollections.toLowerCase().indexOf('Cakes for Today or Tomorrow'.toLowerCase()) > -1
     ) {
    special = true;
  } else {
    noSpecial = true;
  }

  
}

var CRskipUpdateFormAction = true;
//var crSavePickupProperties = true;
var t = new Date()
var currentDay = t.getDate();
var currentMonth = t.getMonth();
var currentyear = t.getFullYear();
var weekDay = t.getDay();
var currentHour = t.getHours()


if (deliveryEnabled === true) {
	storePickupSettings.shippingEnabled = false;
}


document.addEventListener('crPickupActivated', function (e) {
  setTimeout(function(){
    //jqCR('#extra_input_1_label').html('<span class="cr-extra1">Ab wann soll Deine Bestellung zur Abholung bereitstehen?</span><br><br>Abholungen sind möglich:<br>Mo-Do von 10:00 bis 18:00<br>Fr-So von 10:00 bis 19:00')

    // Added the checkbox
    /*jqCR('#pickup-email').after(
    '<div style="display:flex;align-items:center;gap:5px;margin-top:10px;" id="cr-flexible">' +
        '<input type="checkbox" id="pickup-consent" name="attributes[Flexible]" style="width:22px;height:22px;">' +
        '<div style="font-size:12px;">Flexible Lieferung - Es ist in Ordnung, wenn meine Bestellung nach dem gewählten Lieferzeitfenster geliefert wird, solange sie vor der oben angegebenen Uhrzeit eintrifft.</div>' +
    '</div>'
    );

    jqCR(document).on('change', '#pickup-consent', function () {
        const attributes = {};
        attributes['flexible'] = jqCR(this).is(':checked');

        storePickup.updateCartAttributes(attributes);
    });*/

  }, 300)
})


document.addEventListener('crJQActivated', function (e) {
  if (deliveryEnabled === true) {	
  	jqCR('.cr-shipping-method').hide()
  }  
console.log('---------------->', deliveryDisabled)
  if (deliveryDisabled === true) {
    jqCR('.pickup-wrapper').remove()
  }
})
